import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { VoteType } from "../../chatTypes.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { sanitizeText } from "../../utils/sanitizeText.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import { MessageFooterWithVote } from "../MessageFooter/MessageFooterWithVote.js";
import { CitationsSources } from "../MetadataMarker/CitationsSources.js";
import PennyChatBubble from "../PennyChatBubble/index.js";
import { CustomMarkdown } from "./CustomMarkdown.js";
const ClientMarkdownParsingComponent = (props)=>{
    const { fullStreamingTexts, setiValues } = useContext(ChatbotDataContext) || {};
    const { message, finalTexts, webSearchResult, isMobile, isLastMessage, submitChatMessageInMarkerComponent } = props;
    const isStreaming = isLastMessage && fullStreamingTexts?.length > 0;
    const sanitizedText = useMemo(()=>sanitizeText(finalTexts), [
        finalTexts
    ]);
    const footerMessage = {
        content: finalTexts,
        role: 'assistant',
        vote: VoteType.NONE,
        date: message?.date
    };
    const messageContent = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(CustomMarkdown, {
                isStreaming: isStreaming,
                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
                children: sanitizedText
            }),
            !isStreaming && webSearchResult?.length > 0 && /*#__PURE__*/ jsx(CitationsSources, {
                citationsMeta: [],
                webSearchResult: webSearchResult
            })
        ]
    });
    return setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
        message: message,
        children: messageContent
    }) : /*#__PURE__*/ jsx(ChatMessage, {
        variation: "initial",
        Icon: TravelBotLogoImage,
        message: messageContent,
        footer: /*#__PURE__*/ jsx(MessageFooterWithVote, {
            footerMessagePrefix: "Penny",
            isNotUser: true,
            isGreetingMessage: false,
            isMobile: isMobile,
            message: footerMessage
        })
    });
};
export { ClientMarkdownParsingComponent };
